import React from 'react'
import PropTypes from 'prop-types'
import NRTVerticalStack from '../_common/_containers/VerticalStack'
import NRTFormInput from '../_common/_form/FormInput'
import {Validators} from '../_common/_form/Validators'
import NRTButton from '../_common/_buttons/Button'
import NRTFormStateManager from '../_common/_form/FormStateManager'
import debounce from 'debounce'
import PersonRequests from "../../requests/person-requests"
import _ from 'lodash'
import Spinner from '../_common/Spinner';
const md5 = require('md5')

const SIMULATE_USER_SIGN_UP_ERROR = false


class NRTFormUserSignUp extends React.Component {


    state = {
        loading: false
    }


    formChanged = form => {
        this.setState({form})
    }


    submit = () => {
        this.setState({ loading: true })

        this.form.validate()
        const schema = this.props.schema

        if (!this.state.form.valid || this.state.form.dirty === false)
            return null

        const {form} = this.state

        const personDTOToSave = {...form.values}

        delete personDTOToSave['confirmPassword']

        const cpf = form.values.cpfCnpj
        personDTOToSave.password = md5(personDTOToSave.password)
        personDTOToSave.login = `${schema}.${cpf}`
        personDTOToSave.types = '2'
        personDTOToSave.type = 2


        const req = SIMULATE_USER_SIGN_UP_ERROR ?
            Promise.reject() : PersonRequests.save(personDTOToSave, true)

        req
            .then(person => {
                this.setState({ loading: false })

                if (person.success)
                    this.props.onSuccess(person)
                else
                    this.props.onFail(_.get(person , 'errorMessages[0]', ''))

            })
            .catch(error => {
                console.error(error)
                this.props.onFail()
                this.setState({ loading: false })
            })
    }


    passwordChanged = (name, value) => {
        this.setState({password: value})
    }

    passwordChangedDebounced = debounce(this.passwordChanged, 200)

    confirmPasswordValidate = () => {
        return value => {
            if (this.state.password === value) return null

            return 'Senhas não conferem.'
        }
    }


    render() {
        return (
            <NRTFormStateManager ref={f => (this.form = f)} onStateChange={this.formChanged}>
                <NRTVerticalStack>
                    <NRTFormInput label={'CPF*'}
                                  name={'cpfCnpj'}
                                  type={'cpf'}
                                  validators={[Validators.required()]}
                    />

                    <NRTFormInput label={'Nome*'}
                                  name={'name'}
                                  type={'text'}
                                  validators={[Validators.required()]}
                    />

                    <NRTFormInput label={'E-mail*'}
                                  name={'email'}
                                  type={'text'}
                                  validators={[Validators.required(), Validators.email()]}
                    />

                    <NRTFormInput label={'Celular*'}
                                  name={'phoneOne'}
                                  type={'phone'}
                                  validators={[Validators.required()]}
                    />

                    <NRTFormInput
                        label={'Senha*'}
                        name={'password'}
                        customProps={{
                            type: 'password'
                        }}
                        validators={[Validators.required()]}
                        onChange={this.passwordChangedDebounced}
                    />

                    <NRTFormInput
                        label={'Confirmar senha*'}
                        name={'confirmPassword'}
                        customProps={{
                            type: 'password'
                        }}
                        validators={[Validators.required(), this.confirmPasswordValidate()]}
                    />

                    <NRTButton onClick={this.submit}
                               content={this.state.loading ? <Spinner width={32}/> : 'Confirmar'}
                    />
                </NRTVerticalStack>
            </NRTFormStateManager>
        )
    }
}

NRTFormUserSignUp.propTypes = {
    schema: PropTypes.string.isRequired,
    onSuccess: PropTypes.func.isRequired,
    onFail: PropTypes.func.isRequired,
}

NRTFormUserSignUp.defaultProps = {}

export default NRTFormUserSignUp



// WEBPACK FOOTER //
// ./src/components/FormUserSignUp/index.js